export default function (val) {
  return val !== undefined && val !== null;
}